const state = {
  tenancy: {},
  tenancy_map: [],
  currency: '',
  locale: '',
  storesLoaded: false,
  fetchingStores: true
}

const getters = {
  tenancy: state => state.tenancy,
  currency: state => state.currency,
  currencySymbol: state => state.currency ? Intl.NumberFormat('en', { style: 'currency', currency: state.currency })
    .format(0).replace(/\d+([,.]\d+)?/g, '') : '',
  locale: state => state.locale,
  stores: state => {
    return state.tenancy_map.map((item) => {
      return {
        id: item.id,
        name: item.name,
        code: item.code,
        url: item.url,
        color: item.color
      }
    })
  },
  storesLoaded: state => state.storesLoaded,
  fetchingStatus: state => state.fetchingStores
}

const mutations = {
  SET_TENANCY (state, tenancy) {
    this._vm.$vuetify.theme.primary = tenancy ? tenancy.color : this._vm.$vuetify.theme.brand_primary
    if (tenancy) {
      localStorage.setItem('store-code', tenancy.code)
      state.tenancy = tenancy
    }
  },
  ADD_STORE (state, store) {
    state.tenancy_map.push(store)
  },
  UPDATE_STORE (state, store) {
    state.tenancy_map = state.tenancy_map.map((item) => {
      if (item.code === store.code) {
        item.color = store.color.hex || store.color
        item.url = store.url
        item.name = store.name
      }
      return item
    })
  },
  DELETE_STORE (state, code) {
    state.tenancy_map = state.tenancy_map.filter((item) => {
      return item.code !== code
    })
  },

  SET_FETCHING (state, status) {
    state.fetchingStores = status
  },

  SET_STORES_LOADED (state, status) {
    state.storesLoaded = status
  },

  SET_CURRENCY (state, currency) {
    state.currency = currency
  },

  SET_LOCALE (state, locale) {
    state.locale = locale
  }
}

const actions = {
  setStore ({ state, commit }, store) {
    let tenancy = state.tenancy_map.find(t => t.code === store)
    if (tenancy === undefined && state.tenancy_map.length > 0) {
      tenancy = state.tenancy_map[0]
    }
    commit('SET_TENANCY', tenancy)
  },
  addStore ({ commit, state }, store) {
    const item = {
      id: store.id,
      name: store.name,
      color: store.color || '#5A459C',
      url: store.url,
      code: store.code
    }

    let number = state.tenancy_map.findIndex((element) => {
      return element.code === store.code
    })

    if (number === -1) {
      commit('ADD_STORE', item)
      return
    }

    commit('UPDATE_STORE', store)
  },
  updateStore ({ state, commit }, store) {
    if (state.tenancy.code === store.code) {
      this._vm.$vuetify.theme.primary = store.color.hex || store.color
    }
    commit('UPDATE_STORE', store)
  },
  deleteStore ({ commit }, storeId) {
    commit('DELETE_STORE', storeId)
  },
  setFetchingStoresStatus ({ commit }, status) {
    commit('SET_FETCHING', status)
  },
  setStoresLoadedStatus ({ commit }, status) {
    commit('SET_STORES_LOADED', status)
  },
  setCurrency ({ commit }, currency) {
    if (currency !== undefined) {
      commit('SET_CURRENCY', currency)
    }
  },
  setLocale ({ commit }, locale) {
    if (locale !== undefined) {
      commit('SET_LOCALE', locale)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
